import React from 'react';
import { styleDefinitions as styles } from '../../theme/styles';
import { Layout, Table, Maximize2, Minimize2 } from 'lucide-react';

interface ViewToggleProps {
  viewMode: 'tree' | 'table';
  onViewModeChange: (mode: 'tree' | 'table') => void;
  onExpandAll: () => void;
  onCollapseAll: () => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({
  viewMode,
  onViewModeChange,
  onExpandAll,
  onCollapseAll}) => {
  return (
    <div style={styles.components.viewToggle.container}>
      <div style={styles.components.viewToggle.buttonGroup}>
        <button
          onClick={() => onViewModeChange('tree')}
          style={{
            ...styles.components.viewToggle.button,
            ...(viewMode === 'tree' && styles.components.viewToggle.buttonActive)
          }}
          title="Grouped View"
        >
          <Layout size={18} />
          <span>Grouped</span>
        </button>
        <button
          onClick={() => onViewModeChange('table')}
          style={{
            ...styles.components.viewToggle.button,
            ...(viewMode === 'table' && styles.components.viewToggle.buttonActive)
          }}
          title="Table View"
        >
          <Table size={18} />
          <span>Table</span>
        </button>
      </div>

      {viewMode === 'tree' && (
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            onClick={onExpandAll}
            style={styles.components.viewToggle.iconButton}
            title="Expand All"
          >
            <Maximize2 size={18} style={{ color: '#3b82f6' }} />
          </button>
          <button
            onClick={onCollapseAll}
            style={styles.components.viewToggle.iconButton}
            title="Collapse All"
          >
            <Minimize2 size={18} style={{ color: '#3b82f6' }} />
          </button>
        </div>
      )}
    </div>
  );
};